<ng-template #modalContent let-modal modal-dialog>
    <div class="modal-header border-bottom p-3">
        <h6 id="offcanvasAddUserLabel" class="offcanvas-title">{{ 'StockTransfer' | translate }} </h6>
        <button type="button" class="btn-close close-modal-button text-reset" (click)="modal.dismiss('Cross click')"
            aria-label="Close"></button>
    </div>
    <div class="modal-body mx-0 flex-grow-0" [ngClass]="{'alert-form-box': shakeFrom==true}">

        <div class="row modal-body-form">
            <div class="col-12 mb-2">
                <div class="edit-form box-information p-1">

                    <label class="form-label" for="drugBrandName">
                        {{ 'drugBrandName' |translate }}
                    </label>
                    <p class="text-center m-0">
                        {{ data.brandName | slice:0:37}}
                    </p>

                </div>
            </div>
            <div class="col-12 col-md-3 col-lg-4 mb-1">
                <div class="edit-form box-information p-1">

                    <label class="form-label" for="expierDate">
                        {{ 'expierDate' |translate }}
                    </label>
                    <p class="text-center m-0">
                        {{ data.expireDate | dataType :'' }}
                    </p>

                </div>
            </div>
            <div class="col-12 col-md-3 col-lg-4 mb-1">
                <div class="edit-form box-information p-1">

                    <label class="form-label" for="drugPackage">
                        {{ 'drugPackage' |translate }}
                    </label>
                    <p class="text-center m-0">
                        {{ data.PackageCount | dataType:'' }}
                    </p>

                </div>
            </div>
            <div class="col-12 col-md-5 col-lg-4 mb-1">
                <div class="edit-form box-information p-1">

                    <label class="form-label" for="companyName">
                        {{ 'companyName' |translate }}
                    </label>
                    <p class="text-center m-0">
                        {{ data.companyName | dataType:'' }}
                    </p>

                </div>
            </div>

            <div class="col-6 mt-2">
                <div class="edit-form">
                    <label class="form-label" for="drugCount">
                        {{ 'drugCount' |translate }}
                    </label>
                    <div class="validation-alert">
                        <p>
                            {{countMessage | dataType :'':false}}
                        </p>
                    </div>
                    <input type="number" class="form-control" [max]="this.data.maxCount"
                        [ngClass]="{'is-invalid': countMessage!=''&&countMessage!=null}" id="drugCount"
                        [(ngModel)]="data.count" (keyup)="countKeyUp()" (change)="beTrue()"
                        [ngModelOptions]="{standalone: true}" [attr.placeholder]="'count' |translate">
                </div>
            </div>
            <div class="col-6 mt-2"> 
                <div class="edit-form">

                    <label class="form-label" for="packageCount">
                        {{ 'packageCount' |translate }}
                    </label>
                    <div class="validation-alert">
                        <p>
                            {{countMessage | dataType :'':false}}
                        </p>
                    </div>
                    <input type="number" class="form-control"
                        [ngClass]="{'is-invalid': countMessage!=''&&countMessage!=null}" id="drugCount"
                        max="maxTransfer" [(ngModel)]="packageCount" (keyup)="packageKeyUp()" (change)="packageKeyUp()"
                        [ngModelOptions]="{standalone: true}" [attr.placeholder]="'count' |translate">
                </div>
            </div>
            <div class="col-12 mt-2">
                <div class="edit-form">

                    <label class=" form-label" for="destinationStock">
                        {{ 'destinationStock' |translate }}
                    </label>
                    <div class="validation-alert">
                        <p>
                            {{ destinationMessage }}
                        </p>
                    </div>
                    <!-- <select class="form-select" data-allow-clear="true"
                        [ngClass]="{'is-invalid': destinationMessage!=''&&destinationMessage!=null}"
                        [(ngModel)]="this.data.destinationStockId">
                        <option *ngFor="let item of stocks" [ngValue]="item.id">
                            {{item.persianName}}
                        </option>
                    </select>  -->
                    <select
                            id="stockName"
                            class="form-select input-select-text py-2 Focusable iner-Focusable"
                            [(ngModel)]="newItem.stockId"

                            (change)="nextFocus()"
                          >
                            <option Value="">
                              {{ "SelectOne" | translate }}
                            </option>
                            <option
                              *ngFor="let stock of stockList"
                              [ngValue]="stock.id"
                            >
                              {{ stock.persianName }}
                            </option>
                          </select>
                </div>

            </div>
        </div>

    </div>
    <div class="modal-footer border-top p-3">
        <button type="submit" class="btn btn-primary me-sm-3 me-1 data-submit" (click)="submitModal()">
            {{'Submit' | translate}}
        </button>
        <button type="reset" class="btn btn-label-secondary" (click)="modal.dismiss('Cross click')">
            {{'Cancel' | translate}}
        </button>
    </div>
    <app-loading-panel *ngIf="modalLoading"></app-loading-panel>

</ng-template>



<app-pcsuccess-modal [showModal]="modalSuccessConfirm" (parentAction)="parentAction($event)">
</app-pcsuccess-modal>